import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_backendurl,
    prepareHeaders: (headers) => {
      if (typeof Storage !== 'undefined') {
        const user = JSON.parse(localStorage.getItem('RaselListing'))
        if (user?.token) headers.set('Authorization', `Bearer ${user?.token}`)
      }
      return headers
    },
  }),

  endpoints: (builder) => ({
    forgortChangePassword: builder.mutation({
      query(data) {
        return {
          url: `api/forgort-change-Password`,
          method: 'POST',
          body: data,
        }
      },
    }),
  }),
})

export const { useForgortChangePasswordMutation } = authApi
